var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ModelManageMenu/MenuSection/MenuSection.tsx";
import "core-js/modules/es.array.map.js";
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { buildIdVersionKey } from "../../DependencyTree/model";
import { ModelContent } from "./ModelContent";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MenuSection = /*#__PURE__*/React.memo(function (_ref) {
  var color = _ref.color,
      title = _ref.title,
      models = _ref.models,
      currentEntityData = _ref.currentEntityData;
  var classes = useStyles();
  return /*#__PURE__*/_jsx("div", {
    className: classes.root,
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: classes.header,
        children: [/*#__PURE__*/_jsx("span", {
          className: classes.headerIndicator,
          style: {
            backgroundColor: color
          }
        }), /*#__PURE__*/_jsx("span", {
          className: classes.headerText,
          children: title
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: classes.body,
        children: models.map(function (modelItem, idx, arr) {
          return /*#__PURE__*/_jsx(ModelContent, {
            divider: arr.length - 1 > idx,
            modelItem: modelItem,
            currentEntityData: currentEntityData
          }, buildIdVersionKey({
            id: modelItem.urn,
            version: modelItem.versionId
          }));
        })
      })]
    })
  });
});
MenuSection.displayName = 'MenuSection';
var useStyles = makeStyles(function () {
  return {
    root: {
      marginBottom: '5px',
      marginTop: '17px',
      '&:not(:last-child)': {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
      }
    },
    header: {
      paddingLeft: '12px',
      paddingRight: '12px',
      marginBottom: '3px',
      verticalAlign: 'center'
    },
    headerIndicator: {
      display: 'inline-block',
      width: '6px',
      height: '6px',
      borderRadius: '3px',
      marginRight: '6px'
    },
    headerText: {
      fontSize: '10px',
      color: '#616184'
    },
    body: {
      paddingLeft: '24px'
    }
  };
});